import { Descriptions } from 'antd';
import { Duration } from 'dayjs/plugin/duration';

import { GetIndicatorResultsQuery } from 'generated/graphql';

import { useBuildTotalAvailabilityDescriptionItems } from './use-build-total-availability-description-items';

interface TotalAvailabilityTableProps {
  totalTasksTime: Duration;
  totalCriticalTasksTime: Duration;
  indicators: NonNullable<
    GetIndicatorResultsQuery['calculateIndicatorResults']
  >['data'];
}

export const TotalAvailabilityTable = ({
  totalTasksTime,
  totalCriticalTasksTime,
  indicators,
}: TotalAvailabilityTableProps) => {
  const items = useBuildTotalAvailabilityDescriptionItems({
    totalTasksTime,
    totalCriticalTasksTime,
    indicators,
  });

  return (
    <Descriptions
      items={items}
      column={{ xs: 1, sm: 6, md: 6, lg: 6, xl: 6, xxl: 6 }}
      className="header-info"
      bordered={false}
    />
  );
};
